import React from 'react';
import { Routes, Route } from 'react-router-dom';
// import HomePage from './pages/HomePage/HomePage';
import DiagnosticAPage from './pages/DiagnosticA/DiagnosticAPage';
import DiagnosticBPage from './pages/DiagnosticB/DiagnosticBPage';
import WrapperDiagnostic from './pages/DiagnosticB/WrapperDiagnostic';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';
// Importa otras páginas según sea necesario
const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/madurez-digital"
        element={
          <WrapperDiagnostic>
            <DiagnosticBPage />
          </WrapperDiagnostic>
        }
      />
      <Route path="/diagnostico-inicial" element={<DiagnosticAPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
